import React, { ReactElement } from 'react';

import { Icon as SidebarIcon } from '@iconify/react';

import { ReactComponent as ResearcherIcon2 } from '~/assets/icons/researcher-sidebar-icon2.svg';
import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import {
  AdvancedArticleGeneratorRoute,
  AiDetectorRoute,
  AiHumanizerRoute,
  AiResearcherRoute,
  FactCheckerRoute,
  PaperWriterRoute,
  ParaphraseTextRoute,
  PlagiarismCheckerRoute,
  QuizGeneratorRoute,
  RewriteArticleRoute,
  SummarizeTextRoute,
  ToolRoute,
  ToolsGalleryRoute,
} from '~/modules/tools';
import {
  AiResearcherSidebarKey,
  ToolsSidebarKey,
} from '~/modules/tools/constants';
import analytics from '~/services/analytics';

router.addPrivateRoutes([
  ToolsGalleryRoute,
  AdvancedArticleGeneratorRoute,
  PaperWriterRoute,
  PlagiarismCheckerRoute,
  AiDetectorRoute,
  AiHumanizerRoute,
  ParaphraseTextRoute,
  SummarizeTextRoute,
  RewriteArticleRoute,
  AiResearcherRoute,
  FactCheckerRoute,
  QuizGeneratorRoute,
  ToolRoute,
]);

sidebar.addItems({
  a: [
    {
      order: 2,
      key: ToolsSidebarKey,
      path: ToolsGalleryRoute.path,
      getTitle: ToolsGalleryRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'tools',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            icon={isActive ? `flowbite:grid-solid` : `flowbite:grid-outline`}
          />
        );
      },
    },
    {
      order: 4,
      key: AiResearcherSidebarKey,
      path: AiResearcherRoute.path,
      getTitle: AiResearcherRoute.getTitle,
      getLabel: (): string => '',
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'ai_researcher',
        });
      },
      Icon: (): ReactElement => <ResearcherIcon2 />,
    },
  ],
});
